import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4rem 2rem;
  justify-content: center;
  align-items: center;
`;

export const ContentContainer = styled.div<{
  $isSpecialPage?: boolean;
  $align?: 'left' | 'center';
}>`
  margin: 0 auto;
  text-align: ${({ $align }) => $align || 'center'};
  max-width: ${({ $isSpecialPage }) =>
    $isSpecialPage ? '110rem' : '113.4rem'};
`;

export const Title = styled.h2<{
  $isSpecialPage?: boolean;
  $align?: 'left' | 'center';
}>`
  text-align: ${({ $align }) => $align || 'center'};
  font-size: ${({ $isSpecialPage }) => ($isSpecialPage ? '39px' : '40px')};
  font-weight: 900;
  line-height: 115%;
  color: #27343d;
`;

export const Paragraph = styled.p<{
  $align?: 'left' | 'center';
}>`
  font-size: 22px;
  font-weight: 400;
  line-height: 150%;
  text-align: ${({ $align }) => $align || 'center'};
  color: #27343d;
`;
